import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {PullRequestErrorState} from '../components/PullRequestErrorState'
import type {FilesRoutePayload} from '../page-data/payloads/files'
import {DiffComparisonViewer} from '../components/DiffComparisonViewer'

// entrypoint for JSON route - not DataRouter
export function FilesEntrypoint() {
  return (
    <ErrorBoundary critical fallback={<PullRequestErrorState text="Changes cannot be loaded" />}>
      <Files />
    </ErrorBoundary>
  )
}

export function Files() {
  const routeData = useRoutePayload<FilesRoutePayload>()

  return <DiffComparisonViewer {...routeData} useCommenting useFileTree useToolbar />
}

try{ FilesEntrypoint.displayName ||= 'FilesEntrypoint' } catch {}
try{ Files.displayName ||= 'Files' } catch {}